import React from "react";

export const InstagramFilled = ({ size = 20 }: { size?: number }) => {
  return (
    <svg
      width={`${size}px`}
      height={`${size}px`}
      viewBox="0 0 50 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16 3C8.83 3 3 8.83 3 16V34C3 41.17 8.83 47 16 47H34C41.17 47 47 41.17 47 34V16C47 8.83 41.17 3 34 3H16ZM37 11C38.1 11 39 11.9 39 13C39 14.1 38.1 15 37 15C35.9 15 35 14.1 35 13C35 11.9 35.9 11 37 11ZM25 14C31.07 14 36 18.93 36 25C36 31.07 31.07 36 25 36C18.93 36 14 31.07 14 25C14 18.93 18.93 14 25 14ZM25 16C20.04 16 16 20.04 16 25C16 29.96 20.04 34 25 34C29.96 34 34 29.96 34 25C34 20.04 29.96 16 25 16Z"
        fill="currentColor"
      />
    </svg>
  );
};
